/**
 * Dates as the reader's clock shows them.
 *
 * Slicing an ISO string gives UTC, so an estimate issued at 6pm in Calgary
 * prints tomorrow's date. This mattered twice — on the document and on the
 * approval record — which is why it lives here rather than in either.
 */

export function localDate(iso: string, language: string): string {
  const d = new Date(iso);
  // A malformed timestamp should degrade to something readable, not to
  // "Invalid Date" on a customer's estimate.
  if (Number.isNaN(d.getTime())) return iso.slice(0, 10);
  return new Intl.DateTimeFormat(`${language}-u-ca-gregory-nu-latn`, {
    year: 'numeric', month: 'short', day: 'numeric',
  }).format(d);
}
